module.exports = __webpack_public_path__ + "img/AWARDS.0e8e43d0.png";